import UsefulContactsSection from "@/components/UsefulContactsSection";

export default function UsefulContacts() {
  return (
    <div className="py-12 sm:py-16 lg:py-20" data-testid="useful-contacts-page">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <p className="text-xs font-semibold uppercase tracking-widest text-emerald-600 mb-2">Vie locale</p>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="useful-contacts-title">Adresses & numéros utiles</h1>
          <p className="text-base text-slate-600 mt-3">
            Les contacts essentiels autour de la vie scolaire et locale à Toury.
          </p>
        </div>
        <UsefulContactsSection />
      </div>
    </div>
  );
}
